import styled from 'styled-components';
import { LabeledInputMixin } from '../../mixins/components/LabeledInputMixin';
export var StyledLabeledInput = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledLabeledInput",
  componentId: "c11n-8-111-1__sc-ibpk1w-0"
})(["", ""], LabeledInputMixin);